import React, { useEffect, useRef } from "react";
import { Heading } from "rebass";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

interface IProps {
  word1?: string | undefined;
  word1ClassName?: string | undefined;
  word2?: string | undefined;
  word2ClassName?: string | undefined;
  word3?: string | undefined;
  word3ClassName?: string | undefined;
  word4?: string | undefined;
  word4ClassName?: string | undefined;
  className?: string | undefined;
}

const ProjectFadeInTitle = (props: IProps) => {
  const revealRefsFadeInTitle = useRef([null]);
  revealRefsFadeInTitle.current = [];
  useEffect(() => {
    revealRefsFadeInTitle.current.forEach((el, index) => {       
      gsap.fromTo(el, {
        autoAlpha: 0
      }, {
        duration: 0.2, 
        autoAlpha: 1,
        ease: 'Power4.easeOut',
        scrollTrigger: {
          id:`title-${index+1}`,
          trigger: el,
          toggleActions: 'play none none reverse',
          scrub: 0.5,
          //once: true
        }
      });
    });
  }, []);
  const addFadeInTitlesToRefs = (el: any) => {
    if (el && !revealRefsFadeInTitle.current.includes(el)) {
        revealRefsFadeInTitle.current.push(el);
    }
  };

  return (
    <Heading className={props.className!} as="h2" variant="bigTitle">
      <span ref={addFadeInTitlesToRefs} className={props.word1ClassName}>{props.word1}&nbsp;</span>
      {props.word2 !== undefined &&
       <span ref={addFadeInTitlesToRefs} className={props.word2ClassName}>{props.word2}</span>
      }
      <br />
      {props.word3 !== undefined &&
        <span ref={addFadeInTitlesToRefs} className={props.word3ClassName}>{props.word3}&nbsp;</span>
      }
      {props.word4 !== undefined &&
       <span ref={addFadeInTitlesToRefs} className={props.word4ClassName}>{props.word4}</span>
      }
    </Heading>
  )
};

export default ProjectFadeInTitle;